import { motion } from "framer-motion";
import { Card } from "react-bootstrap";

const shimmerAnimation = {
  initial: { x: "-100%" },
  animate: { x: "100%" },
  transition: {
    duration: 1.5,
    repeat: Infinity,
    ease: "linear",
  },
};

const shimmerStyle = {
  background: "linear-gradient(90deg, #f0f0f0 0%, #e0e0e0 50%, #f0f0f0 100%)",
  backgroundSize: "200% 100%",
  animation: "shimmer 1.5s infinite",
};

export default function ProductCardSkeleton() {
  return (
    <Card className="h-100">
      <Card.Body className="p-3">
        <div className="d-flex flex-column h-100">
          {/* Image Skeleton */}
          <div className="position-relative mb-3" style={{ height: "150px" }}>
            <motion.div
              className="w-100 h-100"
              style={{
                backgroundColor: "#f0f0f0",
                borderRadius: "0.5rem",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <motion.div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  ...shimmerStyle,
                }}
                {...shimmerAnimation}
              />
            </motion.div>
          </div>

          {/* Content Skeleton */}
          <div className="flex-grow-1 d-flex flex-column">
            {/* Title Skeleton */}
            <div className="mb-2">
              <motion.div
                style={{
                  height: "24px",
                  width: "80%",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "0.25rem",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <motion.div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    ...shimmerStyle,
                  }}
                  {...shimmerAnimation}
                />
              </motion.div>
            </div>

            {/* Description Skeleton */}
            <motion.div
              style={{
                height: "16px",
                width: "60%",
                backgroundColor: "#f0f0f0",
                borderRadius: "0.25rem",
                overflow: "hidden",
                position: "relative",
                marginBottom: "1rem",
              }}
            >
              <motion.div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  ...shimmerStyle,
                }}
                {...shimmerAnimation}
              />
            </motion.div>

            {/* Price and Button Skeleton */}
            <div className="mt-auto d-flex justify-content-between align-items-center pt-3">
              <motion.div
                style={{
                  height: "24px",
                  width: "40%",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "0.25rem",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <motion.div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    ...shimmerStyle,
                  }}
                  {...shimmerAnimation}
                />
              </motion.div>

              <motion.div
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "50%",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <motion.div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    ...shimmerStyle,
                  }}
                  {...shimmerAnimation}
                />
              </motion.div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
